import React from "react";
import { Placeholder } from "semantic-ui-react";

const CustomPlaceholder = () => (
  <Placeholder style={{ height: 300 }}>
    <Placeholder.Image />
  </Placeholder>
);

export default CustomPlaceholder;
